// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@awc/App/SharedStyles/MyAccountDetailsStyles";
import { headerStyles } from "@awc/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { hideElementOnPrint, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

headerStyles.buttonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        gap: 24px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            & > button {
                width: 100%;
            }
        }
    `,
};
headerStyles.titleGridItem = {
    width: 12,
};

headerStyles.title = {
    variant: "h2",
    as: "h1",
    css: css`
        margin-bottom: 18px;
    `,
};

headerStyles.narrowOverflowMenu = {
    cssOverrides: {
        menu: css`
            ${hideElementOnPrint}
        `,
    },
};

headerStyles.shareEntityButtonStyles = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.emailLink,
};

headerStyles.headerGridContainer = {
    gap: 0,
};

headerStyles.printButton = {
    variant: "primary",
    css: css`
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};
